export default __webpack_public_path__ + "static/logo-bbdf3a1a2e2d6d25852ca12fd712b366.svg";